let apiKey = "f936ebf50157fc0f6ef91e4319108c38";

let searchBoxElement = document.querySelector("#search-box");
searchBoxElement.addEventListener("submit", updateWeather);

function updateWeather(event) {
  event.preventDefault();
  if (event.submitter.id === "search-button") {
    let inputCityNameElement = document.querySelector("#text-box");
    let cityName = inputCityNameElement.value;
    let units = "imperial";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${apiKey}&units=${units}`;
    axios.get(apiUrl).then(getCity);
  } else {
    navigator.geolocation.getCurrentPosition(getLocation);
  }
}

function getLocation(position) {
  let latitude = position.coords.latitude;
  let longitude = position.coords.longitude;
  let units = "imperial";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=${units}`;
  axios.get(apiUrl).then(getCity);
}
function getForecast(coordinates) {
  console.log(coordinates);
  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apiKey}&units=imperial`;
  axios.get(apiUrl).then(displayForecast);
}

function getCity(response) {
  let temperature = Math.round(response.data.main.temp);
  let humidity = response.data.main.humidity;
  let wind = Math.round(response.data.wind.speed);
  let clouds = response.data.weather[0].main;

  fahrenheitTemperature = temperature;

  let tempElement = document.querySelector("#temperature");
  tempElement.innerHTML = temperature;

  let humidityElement = document.querySelector("#humidity");
  humidityElement.innerHTML = humidity;

  let windElement = document.querySelector("#wind");
  windElement.innerHTML = wind;

  let sunnyElement = document.querySelector("#clouds");
  sunnyElement.innerHTML = clouds;

  let cityElement = document.querySelector("#city-name");
  cityElement.innerHTML = response.data.name;

  let icon = response.data.weather[0].icon;

  let iconElement = document.querySelector("#icon");
  iconElement.setAttribute(
    "src",
    `http://openweathermap.org/img/wn/${icon}@2x.png`
  );
  let seconds = response.data.dt;
  let lastUpdated = new Date(seconds * 1000);

  let dateElement = document.querySelector("#date");
  dateElement.innerHTML = formatDate(lastUpdated);

  getForecast(response.data.coord);
}

function formatDate(date) {
  let hours = date.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let day = days[date.getDay()];
  return `${day} ${hours}:${minutes}`;
}

function formatDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return days[day];
}

function displayForecast(response) {
  let forecastElement = document.querySelector("#weather-forecast");
  let forecast = response.data.daily;
  let forecastHTML = `<div class="row">`;

  forecast.forEach(function (forecastDay, index) {
    if (index < 6) {
      console.log(forecastDay);
      forecastHTML =
        forecastHTML +
        `
      <div class="col-2">
        <div class="weather-forecast-date">${formatDay(forecastDay.dt)}</div>
        <img src="http://openweathermap.org/img/wn/${
          forecastDay.weather[0].icon
        }@2x.png" width="45" />
        <div class="weather-forecaset-temperature">
          <span class="weather-forecaset-temperature-max"> ${Math.round(
            forecastDay.temp.max
          )} </span>
          <span class="weather-forecaset-temperature-min"> ${Math.round(
            forecastDay.temp.min
          )} </span>
        </div>
      </div>
    `;
    }
  });

  forecastHTML = forecastHTML + `</div>`;
  forecastElement.innerHTML = forecastHTML;
}

function showcelsiustemperature(event) {
  event.preventDefault();
  let temperatureElement = document.querySelector("#temperature");
  let celsiusTemperature = (fahrenheitTemperature * 5) / 9 + 32;
  celsiuslink.classList.add("active");
  fehreneitlink.classList.remove("active");
  temperatureElement.innerHTML = Math.round(celsiusTemperature);
}

function showfehrenheittemperature(event) {
  event.preventDefault();
  let temperatureElement = document.querySelector("#temperature");
  celsiuslink.classList.remove("active");
  fehreneitlink.classList.add("active");

  temperatureElement.innerHTML = fahrenheitTemperature;
}

let fahrenheitTemperature = null;

let celsiuslink = document.querySelector("#celsius-link");
celsiuslink.addEventListener("click", showcelsiustemperature);

let fehreneitlink = document.querySelector("#fehreneit-link");
fehreneitlink.addEventListener("click", showfehrenheittemperature);

let cityName = "San Francisco";
let units = "imperial";
let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${apiKey}&units=${units}`;
axios.get(apiUrl).then(getCity);

//PaigeNotes:
// let dateElement = document.querySelector("#date");
//get the button in html and listen for the event (called current)
//addeventListener is a function that takes a string and a function to call whenever the event happens defined by the string.
//when im executing this funtion get that location
// event = parameter
//getCurrentPosition will call the function getLocation w/ the position when user accepts "allow access" prompt.
//The text within the st.Louis element should be what you typed in the input element in the seach box.
// = means should be or will be or set at. Think of it this way.
//PaigeNotes: .value means get the text in the input box (seach box) of the city and display it but you still need innerHTML = to set it.
// Use debugger to walk through your code.
// reminder: functions take data in and spit something out
// read it in the order you're calling things.
// axios.<method> will now provide autocomplete and parameter typings
//fyi-cannot have variables with hyphens
//think of 'axios.get' as a function that gets website information.
